import { render, staticRenderFns } from "./LayoutImage.vue?vue&type=template&id=1d06be3b"
import script from "./LayoutImage.vue?vue&type=script&lang=js"
export * from "./LayoutImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports